import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {resubscribeAllVisitorNotificationsAction} from '../../../store/data/preferences/preferencesActions';
import {getIsVisitorSubscribedAll} from '../../../store/data/preferences/preferencesSelectors';
import {VisitorUnsubscribedAllBanner} from './visitorUnsubscribedAllBanner';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isVisitorSubscribedAll: getIsVisitorSubscribedAll,
}));

export const VisitorUnsubscribedAllBannerContainer = connect(mapStateToProps, {
  resubscribeAllVisitorNotifications: resubscribeAllVisitorNotificationsAction,
})(VisitorUnsubscribedAllBanner);
